module.exports = __webpack_public_path__ + "static/media/Zoom.17c00289.svg";